(function () {
    "use strict";

    var COUNTRY_BRASIL = "BRASIL";

    angular
        .module("showcaseApp")
        .component("addressForm", {
            bindings: {
                model: "=",
                form: "<",
                previousZipCode: "<?",
                showCountry: "<?",
                formLayout: "<?",
                required: "<?",
                showReferencePoint: "<?",
                allFieldsRequired: "<?",
                onAddressChange: "&?"
            },
            controller: AddressFormController,
            controllerAs: "$ctrl",
            templateUrl: "app/components/address-form/address-form.html"
        });

    /** @ngInject */
    function AddressFormController($scope, $timeout, GoogleMapsService) {
        var vm = this;
        vm.states = getAllStates();
        vm.countries = getAllCountries();
        vm.debounceTimeout = null;
        vm.cepInvalid = false;

        vm.$onInit = function () {
            vm.showCountry = vm.showCountry || false;
            vm.formLayout = vm.formLayout || false;
            vm.required = vm.required || false;
            vm.showReferencePoint = vm.showReferencePoint || false;
            vm.allFieldsRequired = vm.allFieldsRequired || false;
            if (vm.showCountry && vm.model) {
                $scope.$watch(function () { return vm.model && vm.model.country; }, function (newCountry, oldCountry) {
                    if (oldCountry === COUNTRY_BRASIL && newCountry && newCountry !== COUNTRY_BRASIL) {
                        vm.model.state = "";
                    }
                });
            }
        };

        vm.lastRawZipcode = "";

        vm.checkCEP = function () {
            var rawZipcode = (vm.model.zipcode || "").trim();
            var zipcode = rawZipcode.replace(/\D/g, "");
            var isBrazil = vm.isBrazilRule();
            
            if (rawZipcode && rawZipcode === vm.lastRawZipcode) {
                return;
            }

            var shouldSearch = !isBrazil
                ? (rawZipcode && rawZipcode.length >= 4 && rawZipcode !== (vm.previousZipCode || "").trim())
                : (zipcode && zipcode.length === 8 && zipcode !== (vm.previousZipCode || "").replace(/\D/g, ""));
                
            if (shouldSearch && vm.model) {
                vm.lastRawZipcode = rawZipcode;
                vm.model.address = "";
                vm.model.addressNumber = "";
                vm.model.district = "";
                vm.model.city = "";
                vm.model.state = "";
                vm.cepInvalid = false;
                vm.searchAddress(!isBrazil ? rawZipcode : zipcode);
            }
        };

        vm.searchAddress = function (addressToSearch) {
            if (vm.debounceTimeout) {
                $timeout.cancel(vm.debounceTimeout);
            }
            vm.debounceTimeout = $timeout(function () {
                GoogleMapsService.getAddress(addressToSearch)
                    .then(function (response) {
                        vm.cepInvalid = !response || !response.address_components;
                        if (vm.cepInvalid || !vm.model) {
                            return;
                        }
                        var addressComponents = response.address_components;
                        var hasCity = false;
                        var hasAddress = false;
                        var localityValue = "";
                        var sublocalityValue = "";
                        addressComponents.forEach(function (component) {
                            var types = component.types;
                            types.forEach(function (type) {
                                if (type === "country" && vm.showCountry) {
                                    vm.model.country = mapGoogleCountryToEnumKey(component.short_name, component.long_name);
                                } else if (type === "route") {
                                    vm.model.address = component.long_name;
                                    hasAddress = true;
                                } else if (type === "sublocality_level_1" || type === "sublocality") {
                                    sublocalityValue = component.long_name;
                                    if (!vm.model.district) {
                                        vm.model.district = component.long_name;
                                    }
                                } else if (type === "locality") {
                                    localityValue = component.long_name;
                                    if (!vm.model.district) {
                                        vm.model.district = component.long_name;
                                    }
                                } else if (type === "administrative_area_level_2") {
                                    vm.model.city = component.long_name;
                                    hasCity = true;
                                } else if (type === "administrative_area_level_1") {
                                    vm.model.state = component.short_name;
                                }
                            });
                        });
                        if (!hasCity && (localityValue || sublocalityValue)) {
                            vm.model.city = localityValue || sublocalityValue;
                        }
                        if (!hasAddress && sublocalityValue) {
                            vm.model.address = vm.model.address || sublocalityValue;
                        }
                        if (vm.onAddressChange) {
                            vm.onAddressChange();
                        }
                    })
                    .catch(function (error) {
                        console.error("Error zipcode google: ", error)
                        vm.cepInvalid = true;
                    });
            }, 300);
        };

        vm.isBrazilRule = function () {
            if (vm.showCountry) {
                return vm.model && vm.model.country === COUNTRY_BRASIL;
            }
            return true;
        };
    }

    function mapGoogleCountryToEnumKey(shortName, longName) {
        var ln = (longName || "").toUpperCase();
        var sn = (shortName || "").toUpperCase();
        if (ln === "BRAZIL" || ln === COUNTRY_BRASIL || sn === "BR") {
            return COUNTRY_BRASIL;
        }
        var countries = getAllCountries();
        for (var i = 0; i < countries.length; i++) {
            if ((countries[i].name || "").toUpperCase() === ln) {
                return countries[i].key;
            }
        }
        return longName || "";
    }
})();
